import { baseApi } from './baseApi';

// Types
export interface HealthAIImage {
  type: string;
  data: string;
}

export interface HealthAIRequest {
  health_report_json: any;       // Accepts raw JSON score or string
  images: HealthAIImage[];       // Base64 images
}

export interface HealthAIResponse {
  results: any;
  summary?: string;
  recommendations?: string[];
}

export const healthAnalysisApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // ⭐ POST: Health AI Analysis
    analyzeHealthAI: builder.mutation<
      HealthAIResponse,
      { userId: string; payload: HealthAIRequest }
    >({
      query: ({ userId, payload }) => ({
        url: `/health-ai/analyze/${userId}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['HealthAnalysis'],
    }),

      // ⭐ GET: PDF Report (BLOB)
    getHealthReportPDF: builder.query<Blob, string>({
      query: (assessmentId) => ({
        url: `/health-ai/report/pdf/${assessmentId}`,
        method: "GET",
        responseHandler: async (response) => {
          return await response.blob();  // <-- convert to Blob
        },
      }),
    }),

  }),
  overrideExisting: false,
});

export const { useAnalyzeHealthAIMutation, useLazyGetHealthReportPDFQuery } = healthAnalysisApi;
